import { render, staticRenderFns } from "./EyeChart.vue?vue&type=template&id=550d6a77&scoped=true"
import script from "./EyeChart.vue?vue&type=script&lang=js"
export * from "./EyeChart.vue?vue&type=script&lang=js"
import style0 from "./EyeChart.vue?vue&type=style&index=0&id=550d6a77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550d6a77",
  null
  
)

export default component.exports